import { gql } from '@apollo/client';

export const GENERIC_FILTER_TEMPLATE_GENERAL_DATA_QUERY = gql`
  query genericFilterTemplateGeneralData($id: Int!) {
    genericFilterTemplateGeneralData(id: $id) {
      id
      name
      isTemplate
    }
  }
`;

export const GENERIC_FILTER_TEMPLATE_DETAILS_QUERY = gql`
  query genericFilterTemplateDetails($id: Int!) {
    genericFilterTemplateDetails(id: $id) {
      id
      phrase
      conditions {
        id
        templateId
        paramId
        operatorId
        value
        valueId
        orderNo
        values {
          id
          detailId
          value
          valueId
        }
      }
    }
  }
`;

export const FULL_GENERIC_FILTER_TEMPLATE = gql`
  query fullGenericFilterTemplate($id: Int!) {
    genericFilterTemplateGeneralData(id: $id) {
      id
      name
      isTemplate
    }
    genericFilterTemplateDetails(id: $id) {
      id
      phrase
      conditions {
        id
        templateId
        paramId
        operatorId
        value
        valueId
        orderNo
        values {
          id
          detailId
          value
          valueId
        }
      }
    }
  }
`;

export const PREDEFINED_GENERIC_FILTER_TEMPLATES = gql`
  query predefinedGenericFilterTemplates {
    predefinedGenericFilterTemplates {
      id
      name
    }
  }
`;
